import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_entitlement_auto_top_up_run_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_default_company_guid: fromDatatype.GuidDataFieldInterface;
  claimant_default_company_name: fromDatatype.VarcharDatatypeInterface;
  claimant_job_role: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  topup_amount: fromDatatype.BigIntegerDatatypeClass;
  date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  processor_posting_status: fromDatatype.VarcharDatatypeInterface;
  processor_posting_error: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  generated_claim_account_txn_line_guid: fromDatatype.GuidDataFieldInterface;
  generated_claim_account_txn_line_status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_entitlement_auto_top_up_run_txn_line_RowClass implements
  bl_aat_entitlement_auto_top_up_run_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_default_company_guid: fromDatatype.GuidDataFieldInterface;
  claimant_default_company_name: fromDatatype.VarcharDatatypeInterface;
  claimant_job_role: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  topup_amount: fromDatatype.BigIntegerDatatypeClass;
  date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  processor_posting_status: fromDatatype.VarcharDatatypeInterface;
  processor_posting_error: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  generated_claim_account_txn_line_guid: fromDatatype.GuidDataFieldInterface;
  generated_claim_account_txn_line_status: fromDatatype.VarcharDatatypeInterface;
}
